<script lang="ts" setup>
import { Customer } from '@/core/collections/contracts-api/customers/customer.interface';
import { PropType } from 'vue';
import Dropdown from './Dropdown.vue';

const emits = defineEmits(['update:customerId', 'update:customer']);
defineProps({
   name: { type: String, required: true },
   customerId: { type: [Number, String], default: null },
   placeholder: { type: String, default: null },
   label: { type: String, default: null },
   options: { type: Array as PropType<Array<Customer>>, default: () => [] },
   errors: { type: Object, default: () => ({}) },
   disabled: { type: Boolean, default: false },
   required: { type: Boolean, default: false },
   initialDataCallback: { type: Function, default: null },
   autoSelect: { type: Boolean, default: true },

   searchType: { type: String, default: 'custom' },
});

function changeCustomer(customer?: Customer) {
   emits('update:customer', customer);
   emits('update:customerId', customer?.id);
}
</script>

<template>
   <Dropdown
      :model-value="customerId"
      :search-type="searchType"
      :name="name"
      :label="label"
      :placeholder="placeholder"
      :url="'customer/searchCustomers'"
      :errors="errors"
      :disabled="disabled"
      :required="required"
      :options="options"
      :initial-data-callback="initialDataCallback"
      :emit-object="true"
      :auto-select="autoSelect"
      @update:model-value="changeCustomer"
   />
</template>
